import { useEffect, useState } from 'react'

/**
 * Custom hook to handle countdown logic
 */
export function useCountdown(initialCount: number, onCountdownEnd: () => void) {
  const [count, setCount] = useState(initialCount)

  useEffect(() => {
    if (count <= 0) {
      onCountdownEnd()
      return
    }

    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          onCountdownEnd()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [count, onCountdownEnd])

  return count
}
